var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5002 5.6145C29.5002 3.98533 30.7882 2.66667 32.3752 2.66667C33.9622 2.66667 35.2502 3.98725 35.2502 5.6145C35.2502 6.20292 35.0835 6.74917 34.794 7.20917C33.9354 8.57767 32.3752 9.88483 32.3752 11.5121V12.25M32.3752 16.0833H32.3925M6.84522 24.3173C4.43405 25.7318 -1.8852 28.6164 1.96347 32.2255C3.84372 33.9888 5.93863 35.25 8.57213 35.25H23.595C26.2285 35.25 28.3234 33.9888 30.2017 32.2255C34.0523 28.6164 27.733 25.7299 25.3219 24.3173C22.515 22.69 19.3281 21.833 16.0835 21.833C12.839 21.833 9.65211 22.69 6.84522 24.3173ZM23.7502 8.41667C23.7502 10.45 22.9425 12.4 21.5047 13.8378C20.0669 15.2756 18.1169 16.0833 16.0835 16.0833C14.0502 16.0833 12.1002 15.2756 10.6624 13.8378C9.22462 12.4 8.41688 10.45 8.41688 8.41667C8.41688 6.38334 9.22462 4.43329 10.6624 2.99551C12.1002 1.55774 14.0502 0.75 16.0835 0.75C18.1169 0.75 20.0669 1.55774 21.5047 2.99551C22.9425 4.43329 23.7502 6.38334 23.7502 8.41667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetHelpIcon);
export default __webpack_public_path__ + "static/media/GetHelpIcon.fec0996c3b1fa8045504593b95abf627.svg";
export { ForwardRef as ReactComponent };